import {
  AttendanceCompanySettingsVersionCalculationMethodEnum,
  TimesheetCompanySettingsVersionHistoryFragment,
} from 'generated/resources/graphql'
import { keyBy, mapValues } from 'lodash'

type OvernightShiftsCalculationMethodsByDates = {
  [key: string]: AttendanceCompanySettingsVersionCalculationMethodEnum
}

class CompanySettingsVersionHistories {
  static overnightShiftsCalculationMethodsByDates(
    companySettingsVersionHistories: Pick<
      TimesheetCompanySettingsVersionHistoryFragment,
      'date' | 'overnightShiftsCalculationMethod'
    >[]
  ): OvernightShiftsCalculationMethodsByDates {
    const settingsHistoryByDate = keyBy(companySettingsVersionHistories, 'date')

    return mapValues(settingsHistoryByDate, 'overnightShiftsCalculationMethod')
  }
}

export default CompanySettingsVersionHistories
